var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.5C16 0.223858 16.2239 0 16.5 0H17.5C17.7761 0 18 0.223858 18 0.5V17.5C18 17.7761 17.7761 18 17.5 18H16.5C16.2239 18 16 17.7761 16 17.5V0.5ZM14 6.5C14 6.22386 13.7761 6 13.5 6H12.5C12.2239 6 12 6.22386 12 6.5V17.5C12 17.7761 12.2239 18 12.5 18H13.5C13.7761 18 14 17.7761 14 17.5V6.5ZM6 10.5C6 10.2239 5.77614 10 5.5 10H4.5C4.22386 10 4 10.2239 4 10.5V17.5C4 17.7761 4.22386 18 4.5 18H5.5C5.77614 18 6 17.7761 6 17.5V10.5ZM2 14.5C2 14.2239 1.77614 14 1.5 14H0.5C0.223858 14 0 14.2239 0 14.5V17.5C0 17.7761 0.223858 18 0.5 18H1.5C1.77614 18 2 17.7761 2 17.5V14.5ZM8 12.5C8 12.2239 8.22386 12 8.5 12H9.5C9.77614 12 10 12.2239 10 12.5V17.5C10 17.7761 9.77614 18 9.5 18H8.5C8.22386 18 8 17.7761 8 17.5V12.5ZM5.5 3C5.77614 3 6.00437 3.22554 5.95887 3.49791C5.7217 4.91779 4.48723 6 3 6C1.34315 6 0 4.65685 0 3C0 1.51277 1.08221 0.278305 2.50209 0.0411288C2.77446 -0.00436734 3 0.223858 3 0.5V2.5C3 2.77614 3.22386 3 3.5 3H5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.d14f70fafdb4f42e7ecb762c43787e09.svg";
export { ForwardRef as ReactComponent };